/*------------------------------------------------
// File Name:PDM_MA_Pack.js
// File Description:PDM_MA_Pack store方法
// Author:zxl
// Create Time:2023/06/06 15:39:47
//------------------------------------------------*/

import {
    GetPDM_MA_PackList,
    GetPDM_MA_PackListByPage,
    GetPDM_MA_PackEntity,
    CreatePDM_MA_PackEntity,
    UpdatePDM_MA_PackEntity,
    DeletePDM_MA_PackEntity,
} from '@/api/pdm/ma/maPack'

import msg from '@/config/notify'
import dlg from '@/config/dialog'
//import { toRaw } from "vue";

export const PdmMaPack = {
    namespaced: true,
    state: {
        PdmMaPackList: [],
        PdmMaPackListLoading: false,
        PdmMaPackEntity: null,
        PdmMaPackShowDlg: false,
    },
    mutations: {
        setPdmMaPackList(state, dataList) {
            state.PdmMaPackList = [...dataList]
        },
        setPdmMaPackListLoading(state, visible) {
            state.PdmMaPackListLoading = visible
        },
        setPdmMaPackShowDlg(state, visible) {
            state.PdmMaPackShowDlg = visible
        },
        setPdmMaPackEntity(state, entity) {
            state.PdmMaPackEntity = entity
        },
    },
    actions: {
        //创建预约套餐对象
        actCreatePdmMaPack({ commit }, parm) {
            return new Promise((resolve, reject) => {
                CreatePDM_MA_PackEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmMaPackEntity', res.Data)
                        commit('setPdmMaPackShowDlg', true)
                         //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        reject(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //加载预约套餐对象
        actGetPdmMaPackEntity({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmMaPackListLoading', true)
                GetPDM_MA_PackEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmMaPackEntity', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        //msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmMaPackListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //加载预约套餐列表
        actGetPdmMaPackList({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmMaPackListLoading', true)
                GetPDM_MA_PackList(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmMaPackList', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        //msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmMaPackListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //分页加载预约套餐列表
        actGetPdmMaPackListByPage({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmMaPackListLoading', true)
                GetPDM_MA_PackListByPage(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmMaPackList', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                       // msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmMaPackListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //保存预约套餐信息
        actUpdatePdmMaPack({ commit }, parm) {
            return new Promise((resolve) => {
                UpdatePDM_MA_PackEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmMaPackShowDlg', false)
                        msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        resolve(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //编辑PDM_MA_Pack
        actEditPdmMaPackData({ commit }, entity) {
            return new Promise((resolve) => {
                let parm = {                    
                    PdmMaPackID : entity.PdmMaPackID
                }
                GetPDM_MA_PackEntity(parm).then(res => {
                    if (res.Code == 0) {
                        // var info = {}
                        // Object.assign(info,state.getTableNameL3(TableName.Name)%>Entity)
                        // Object.assign(info,res.Data)
                        // commit('getTableNameL3(TableName.Name)%>Entity', info)
                        commit('setPdmMaPackEntity', res.Data)
                        commit('setPdmMaPackShowDlg', true)
                        msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        resolve(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //编辑PDM_MA_Pack ,传对象过来
        actEditPdmMaPack({ commit }, entity) {
            return new Promise(() => {
                commit('setPdmMaPackEntity', entity)
                commit('setPdmMaPackShowDlg', true)
            }).catch(err => {
                console.log(err)
            })
        },
        //删除PDM_MA_Pack
        actDeletePdmMaPack({ commit }, e) {
            return new Promise((resolve) => {
                dlg.confirm("是否确定要删除当前预约套餐？").onOk(() => {
                    DeletePDM_MA_PackEntity(e).then(res => {
                        if (res.Code == 0) {
                            commit('setPdmMaPackShowDlg', false)
                           
                            msg.success("删除预约套餐成功。")
                            resolve(res)
                        } else {
                            dlg.alert("删除预约套餐失败，原因:" + res.Message)
                            //msg.success("删除预约套餐失败，原因:" + res.Message)
                            resolve(res)
                        }
                    })
                })
            }).catch(err => {
                console.log(err)
            })
        }
    }
}


